import React from "react";
import { useDrag } from "react-dnd";

import { InputCursorText, CardText, UiRadiosGrid, CheckSquare, FileEarmarkArrowUp, MenuButtonWideFill, TypeH1, Hr, Fonts, TagFill } from 'react-bootstrap-icons';

const FormField = ({ fieldType }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FORM_FIELD",
    item: { fieldType },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div ref={drag} style={{ opacity: isDragging ? 0.5 : 1 }}>
      {fieldType === "SingleLine" && (<InputCursorText/>)}
      {fieldType === "MultiLine" && (<CardText/>)}
      {fieldType === "RadioSelect" && (<UiRadiosGrid/>)}
      {fieldType === "Checkbox" && (<CheckSquare/>)}
      {fieldType === "FileUpload" && (<FileEarmarkArrowUp/>)}
      {fieldType === "Dropdown" && (<MenuButtonWideFill/>)}
      {fieldType === "Heading" && (<TypeH1/>)}
      {fieldType === "Divider" && (<Hr/>)}
      {fieldType === "Text" && (<Fonts/>)}
      {fieldType === "Label" && (<TagFill/>)}
      {fieldType}
    </div>
  );
};

export default FormField;
